import styled from 'styled-components'

import { ButtonEditInlineUnstyled } from 'Components/Buttons/ButtonEditInline/unstyled'

export const ButtonEditInline = styled(ButtonEditInlineUnstyled)`
  fill: ${props => props.theme.colors.regentGray};
  font-size: ${props => props.theme.fontSizes.city.card.link};
  color: ${props => props.theme.colors.regentGray};
  display: flex;
  line-height: 16px;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  svg {
    height: 15px;
    width: 18px;
    margin-right: 7px;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonEditInline/index.js